import React, { useState } from 'react';

import PublicPage from 'components/PublicPage';

import { default as SignUpForm } from 'forms/SignUp';
import { signUp } from 'actions';
import useActions from 'hooks/useActions';

const SignUp = ({navbarProps}) => {
  const [signedUp, setSignedUp] = useState(false);
  const dispatchSignUp = useActions(signUp);
  const onSuccess = () => {
    setSignedUp(true);
  };
  const onSubmit = (values) => {
    dispatchSignUp(values, {onSuccess})
  };
  return (
  <PublicPage navbarProps={navbarProps}>
    <div className="container">
      <div className="box my-6 py-6">
        {!signedUp ?
        <SignUpForm onSubmit={onSubmit} />
        :
        <div className="content">
          <p>Merci de votre inscription, vous allez recevoir par email un lien afin de confirmer votre compte</p>
        </div>
        }
      </div>
    </div>
  </PublicPage>
  )
}

export default SignUp;